import { TOKEN } from 'features/auth/constants';
import { clearAuthToken, getAuthToken } from 'features/auth/helpers';
import qs from 'qs';
import { Navigate } from 'react-router-dom';
import { history } from 'routes/history';
import { getPath } from 'routes/router-paths';

type PrivateRouteProps = {
  children: any;
};

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  if (!getAuthToken(TOKEN.REFRESH_TOKEN)) {
    clearAuthToken();
    return (
      <Navigate
        to={getPath(
          'loginPage',
          qs.stringify({
            redirectedFrom: history.location.pathname,
          })
        )}
      />
    );
  }

  return children;
};

export default PrivateRoute;
